/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Input, Tooltip } from "@mantine/core";
import moment from "moment";
import React, { useEffect } from "react";
import htmlParser from 'react-html-parser';
import { AiOutlineInfoCircle } from "react-icons/ai";
import {
  BsArrowRight,
  BsFacebook,
  BsGithub,
  BsStackOverflow,
  BsTwitter
} from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { SiGooglemessages } from "react-icons/si";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/layout_components/Navbar";
import Halment from "../faetures/Halment";
import writer from "../images/asraful style picture.c79bfe20a330d5afdd2c.png";
import logo from "../images/logoipsum-284.svg";
import { allBlogsForSlider, singleBlogDetails } from "../redux/actions/frontendActions/blogActions";
function BlogDetails() {
    const dispatch = useDispatch();
    const {id} = useParams();
  
    const {sliderBlogs, singlePost  } = useSelector(
        (state) => state.Blog
      );





    useEffect(() => {
        dispatch(allBlogsForSlider());
      
      }, []);

      useEffect(() => {
        dispatch(singleBlogDetails(id))
      }, [id]);




  return (
    <>
      <Navbar />
      <Halment title={singlePost.title} />

      {/* hero area  */}
    <div className="blog-details-hero-wrapper">

    <div className="grid_area">
        <div className="left">
            <div className="text-area">
                <h1>{singlePost.title}</h1>
                <p style={{letterSpacing: "2px", padding: "8px 0"}}>{singlePost.tagItems}</p>
       
           
                  
                <p>{moment(singlePost.createdAt).fromNow()}</p>
            </div>
            <div className="writer-area-grid">
                <div className="left-part">
                    <img src={writer} alt="" />
                </div>
                <div className="right-part">
                    <h3>Muhammad Asraful</h3>
                    <span>MERN stack Developer & Wordpress Expert</span>
                </div>
            </div>
        </div>
        <div className="right">
            <img src={singlePost.image} alt="" />
        </div>
    </div>

    <div className="padding_container">
        <div className="description-main-connet ">
            <div className="left">
            <p>{htmlParser(singlePost?.description)}</p>

             
            </div>
            <div className="right">
              <div className="top-area">
                <div className="blog-deatils-title">popular blog</div>
              </div>

              <div className="popular-blog-area">
                {sliderBlogs.length > 0 ? (
                  sliderBlogs.slice(2, 4).map((blog, index) => (
                    <Link to={`/blog/${blog._id}`} className="card" key={ index}>
                      <h2>{blog.title}</h2>
                      <div className="date_flex">
                        <p>{blog.createdAt}</p>
                        <p>Md Asraful</p>
                      </div>
                    </Link>
                  ))
                ) : (
                  <h3>Loading...</h3>
                )}
              </div>

              <div className="newsletter">
                <div className="newsletter-card">
                  <h4 className="news-h4">Subscribe to Newsletter</h4>
                  <p>
                    Enter your email address below to subscribe to my newsletter
                  </p>

                  <div className="submit-area">
                    <div className="form-letter">
                      <Input
                        icon={<MdOutlineEmail />}
                        placeholder="Your email address"
                        rightSection={
                          <Tooltip
                            label="Your gmail is safe"
                            position="top-end"
                            withArrow
                          >
                            <div>
                              <AiOutlineInfoCircle
                                size={18}
                                style={{ display: "block", opacity: 0.5 }}
                              />
                            </div>
                          </Tooltip>
                        }
                      />
                    </div>
                    <div className="btn-letter">
                      <button>
                        Subscribe
                        <BsArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
        </div>
    </div>

    </div>










    {/* footer area  */}
      <div className="footer-contact-wrapper contact_footer ">
        <div className="footer-items-section padding_container ">
          <div className="footer-items">
            <div className="item logo-item">
              <div className="logo">
                <img src={logo} alt="" />
              </div>
              <div className="logo-text">
                Here, I provided my social media links. Before going to a
                argument you firstly contact me.
              </div>
              <div className="logo-svg">
                <Link to="#">
                  <BsFacebook />
                </Link>
                <Link to="#">
                  <FaLinkedin />
                </Link>
                <Link to="#">
                  <BsTwitter />
                </Link>
                <Link to="#">
                  <BsGithub />
                </Link>
                <Link to="#">
                  <BsStackOverflow />
                </Link>
              </div>
              <a href="mailto:iasraful107@gmail.com" className="message-btn">
                <button>
                  <SiGooglemessages size={20} /> Contact Me
                </button>
              </a>
            </div>

            <div className="item">
              <h3>Useful Links</h3>
              <ul>
                <li>
                  <Link to="#">Home</Link>
                </li>
                <li>
                  <Link to="#">About Me</Link>
                </li>
                <li>
                  <Link to="#">Portfolio</Link>
                </li>
                <li>
                  <Link to="#">Articles</Link>
                </li>
                <li>
                  <Link to="#">Services</Link>
                </li>
                <li>
                  <Link to="#">Pricing</Link>
                </li>
              </ul>
            </div>

            <div className="item">
              <h3>Terms & conditions</h3>
              <ul>
                <li>
                  <Link to="#">Privacy & policy</Link>
                </li>
                <li>
                  <Link to="#">Contact Me</Link>
                </li>
                <li>
                  <Link to="#">Refund Policy</Link>
                </li>
              </ul>
            </div>
            <div className="item">
              <h3>Address</h3>
              <ul>
                <li>
                  <p>
                    <a href="#">Gazipur, Dhaka, Bangladesh</a>
                  </p>
                </li>
                <li>
                  <p>
                    <a href="tel:+8801758015756">+8801758015756</a>
                  </p>
                </li>
                <li>
                  <p>
                    <a href="mailto:iasraful107@gmail.com">
                      iasraful107@gmail.com
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="copyright padding_container">
          <hr />
          <br />
          <span>
            Designed & Developed by{" "}
            <span className="green"> Muhammad Asraful</span>
          </span>
        </div>
      </div>
    </>
  );
}

export default BlogDetails;
